export enum FormulaNumpad {
    ADD = "+",
    SUBTRACT = "-",
    DIVIDE = "/",
    MULTIPLY = "*",
    OPEN_PARENTHESIS = "(",
    CLOSED_PARENTHESIS = ")",
    ZERO = "0",
    ONE = "1",
    TWO = "2",
    THREE = "3",
    FOUR = "4",
    FIVE = "5",
    SIX = "6",
    SEVEN = "7",
    EIGHT = "8",
    NINE = "9",
    DELETE = "DEL",
    DECIMAL = "."
}

export enum FormulaNumpadValueType {
    OPENING_BRACKET = "OpeningBracket",
    CLOSING_BRACKET = "ClosingBracket",
    DELETE_BUTTON = "DeleteButton",
    NUMBER = "Number",
    OPERAND = "Operand",
    TRACKER = "Tracker",

}
